// extracted by mini-css-extract-plugin
export default {"box":"InputName_box__fu6zZ","title":"InputName_title__rcbzK","input":"InputName_input__8ELvQ"};